export default __webpack_public_path__ + "static/media/hhn2.b5ff0296.png";